module.exports = __webpack_public_path__ + "static/media/al.5b864f09.webp";